import habitat from 'preact-habitat';

import Widget from './components/app';

let _habitat = habitat( Widget );

_habitat.render( {
	selector     : '[data-widget-id="olympics-news"]',
	defaultProps : {

	},
	clean        : true
} );
